import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";
import { useTranslation } from "react-i18next";

type ReviewCheckboxProps = {
	amISure?: boolean;
	setAmISure?: (value: boolean) => void;
};

const ReviewCheckbox = ({ amISure, setAmISure }: ReviewCheckboxProps) => {
	const { t } = useTranslation();
	return (
		<FormControlLabel
			control={
				<Checkbox
					checked={amISure}
					onChange={() => setAmISure && setAmISure(!amISure)}
					name='amISureCheckbox'
					id='amISureCheckbox'
					color='primary'
				/>
			}
			label={t("scheduler_agree-publish-shifts")}
			style={{ marginRight: "auto", marginLeft: "9px" }}
		/>
	);
};

export default ReviewCheckbox;
